import { integration_key__e_invoice_customer } from "features/Integration/constants/Integration.constants";
import { INTEGRATION_ROUTE_KEYS } from "features/Integration/constants/Integration.urlPaths";
import { navigateTo } from "utils/urlUtils";
import { EINVOICE_TRANSACTION_UUID_FILTER_KEY } from "../constants/ManageEInvoice.constants";

export const navigateToFilteredEInvoiceList = (transactionId) => {
  if (!transactionId) return;

  navigateTo(INTEGRATION_ROUTE_KEYS.integration_details, {
    args: { slug: integration_key__e_invoice_customer },
    queryParams: {
      filter: JSON.stringify({
        [EINVOICE_TRANSACTION_UUID_FILTER_KEY]: transactionId,
      }),
      order: "ASC",
      page: 1,
      perPage: 50,
    },
  });
};
